import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Box } from "@mui/material";
import { isMobile } from 'react-device-detect';

// images
import hcpMobile4En from "../assets/image/tutorial/hcp/mobile/hcpTutorial4-en.png";
import hcpDesktop4En from "../assets/image/tutorial/hcp/desktop/hcpTutorial4-en.png";
import tutorialArrow from "../assets/image/tutorialArrow.png";

const HcpTutorial4 = () => {

    const navigate = useNavigate();

    const [openTutorial, setOpenTutorial] = useState(true);

    return (
        <div>
            {
                isMobile ? (
                    <img src={hcpMobile4En} alt="hcpTutorial" style={{ height: "100vh", width: "100vw" }} />
                ) : (
                    <img src={hcpDesktop4En} alt="hcpTutorial" style={{ height: "100vh", width: "100vw" }} />
                )
            }
            <Modal
                open={openTutorial}
                onClose={() => setOpenTutorial(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                hideBackdrop={true}
            >
                <Box className="tutorial-modal-4">
                    <p style={{ fontSize: "18px" }}>View submissions and redemptions record of all patients</p>
                    <img src={tutorialArrow} alt="arrow" style={{ float: "right" }} onClick={() => navigate('/hcp/hcpTutorial5')} />
                </Box>
            </Modal>
        </div>
    );
};

export default HcpTutorial4;
